import { render, staticRenderFns } from "./edit-json-table.vue?vue&type=template&id=1825d219&scoped=true&"
import script from "./edit-json-table.vue?vue&type=script&lang=js&"
export * from "./edit-json-table.vue?vue&type=script&lang=js&"
import style0 from "./edit-json-table.vue?vue&type=style&index=0&id=1825d219&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1825d219",
  null
  
)

component.options.__file = "edit-json-table.vue"
export default component.exports